import React, { useState } from 'react';

import { useMutation } from 'react-query';
import { useForm } from 'react-hook-form';

import useWindowSize from 'hooks/use-windowSize';

import ActionButton from '@core/components/actionbutton/ActionButton';
import TextInput from '@core/components/textinput/TextInput';
import CartCountrySelect from 'components/pages/cart/CartCountrySelect';

import { billingAddressService } from 'services/auth';

import TickIcon from 'assets/icons/tick-rounded-black.svg';

import classes from './BillingInformationForm.module.scss';

const BillingInformationForm = ({ callback, toast, billingAddress, hasSubmitMsg = false }) => {
	const { mobileDevice } = useWindowSize();
	const [selectedCountry, setSelectedCountry] = useState(billingAddress?.country_iso);
	const { mutate, isLoading } = useMutation(billingAddressService.Post, {
		onSuccess: async (response) => {
			callback && (await callback());
			toast && toast(response.data.message, 'success');
		},
		onError: (error) => {
			toast && toast(error?.response?.data?.data || 'Something went wrong! please try again', 'Alert');
		}
	});

	const {
		register,
		handleSubmit,
		setValue,
		formState: { errors, isDirty, isValid }
	} = useForm({
		mode: 'onChange',
		shouldFocusError: false,
		defaultValues: {
			country_iso: billingAddress?.country_iso,
			postal_code: billingAddress?.postal_code,
			city: billingAddress?.city,
			address_line_1: billingAddress?.address_line_1,
			address_line_2: billingAddress?.address_line_2
		}
	});

	const onSubmitBillingAddress = (formData) => {
		mutate({
			country_iso: selectedCountry.iso2,
			address_line_2: formData.address_line_2?.trim() || null,
			postal_code: formData.postal_code.trim(),
			city: formData.city.trim(),
			address_line_1: formData.address_line_1.trim()
		});
	};
	return (
		<>
			<form
				className={`row ${classes['billing-address-form']}`}
				onSubmit={handleSubmit(onSubmitBillingAddress)}>
				<CartCountrySelect
					validation={{
						required: true
					}}
					input={{
						type: 'text',
						label: 'Country',
						name: 'country',
						placeholder: '',
						id: 'country',
						autoComplete: 'off'
					}}
					errors={errors}
					register={register}
					selectedCountry={selectedCountry}
					setSelectedCountry={setSelectedCountry}
					mobileDevice={mobileDevice}
					setValue={setValue}
					className={`col-12 col-md-6`}
				/>
				<TextInput
					validation={{
						required: true,
                        validate: value => value.trim() !== ''
					}}
					input={{
						type: 'text',
						label: 'City',
						name: 'city',
						placeholder: 'City',
						id: 'city'
					}}
					errors={errors}
					register={register}
					hasErrorMsg={false}
					className={`col-12 col-md-6`}
				/>
				<TextInput
					validation={{
						required: true,
                        validate: value => value.trim() !== ''
					}}
					input={{
						type: 'text',
						label: 'Address Line 1',
						name: 'address_line_1',
						placeholder: 'Address Line 1',
						id: 'address_line_1'
					}}
					errors={errors}
					register={register}
					hasErrorMsg={false}
					className={`col-12`}
				/>
				<TextInput
					input={{
						type: 'text',
						label: 'Address Line 2',
						name: 'address_line_2',
						placeholder: 'Address Line 2',
						id: 'address_line_2'
					}}
					errors={errors}
					register={register}
					hasErrorMsg={false}
					className={`col-12`}
				/>
				<TextInput
					validation={{
						required: true,
                        validate: value => value.trim() !== ''
					}}
					input={{
						type: 'text',
						label: 'Postal Code',
						name: 'postal_code',
						placeholder: 'Postal Code',
						id: 'postal_code'
					}}
					errors={errors}
					register={register}
					hasErrorMsg={false}
					className={`col-12`}
				/>
				{hasSubmitMsg && (
					<div className="d-flex flex-row align-items-center gap-2 mt-3">
						<TickIcon />
						<p className="m-0">your billing information will be saved securely.</p>
					</div>
				)}
				<ActionButton
					type="submit"
					className="w-100"
					loading={isLoading}
					disabled={!isDirty || !isValid}>
					Submit
				</ActionButton>
			</form>
		</>
	);
};

export default BillingInformationForm;
